import { Badge } from "./ui/badge";
import { Database, FlaskConical } from "lucide-react";

/**
 * Displays a badge showing which environment the user is currently in
 */
export function EnvironmentBadge() {
  if (typeof window === 'undefined') return null;
  
  const hostname = window.location.hostname;
  const isStaging = hostname === 'staging.pathkit.pro';
  const isDemo = hostname.endsWith('-demo.pathkit.pro');
  
  if (!isStaging && !isDemo) return null; // Only show in staging or demo environment
  
  if (isStaging) {
    return (
      <Badge 
        variant="outline" 
        className="bg-orange-50 border-orange-500 text-orange-700 dark:bg-orange-900/20 dark:border-orange-600 dark:text-orange-400"
      >
        <FlaskConical className="h-3 w-3 mr-1" />
        Staging Environment
      </Badge>
    );
  }
  
  return (
    <Badge 
      variant="outline" 
      className="bg-yellow-50 border-yellow-500 text-yellow-700 dark:bg-yellow-900/20 dark:border-yellow-600 dark:text-yellow-400"
    >
      <Database className="h-3 w-3 mr-1" />
      Demo Environment
    </Badge>
  );
}

/**
 * Gets the current environment name
 */
export function getEnvironmentName(): string {
  if (typeof window === 'undefined') return 'Unknown';
  const hostname = window.location.hostname;
  if (hostname === 'staging.pathkit.pro') return 'Staging';
  if (hostname.endsWith('-demo.pathkit.pro')) return 'Demo';
  return 'Production';
}

/**
 * Checks if currently in demo environment (includes staging since it uses demo database)
 */
export function isDemoEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.endsWith('-demo.pathkit.pro') || hostname === 'staging.pathkit.pro';
}

/**
 * Checks if currently in staging environment specifically
 */
export function isStagingEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'staging.pathkit.pro';
}
